import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Button,
} from "@mui/material";
import axiosInstance from "../../../utils/axiosConfig";

function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await axiosInstance.get(
        "/service_offerings?offering_type=news"
      );
      setNews(response.data);
    } catch (error) {
      console.error("Error fetching news:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ py: 5, px: 3 }}>
        <Typography variant="h4" sx={{ textAlign: "center", mb: 3 }}>
          Noticias Recientes
        </Typography>
        <Typography sx={{ textAlign: "center" }}>Cargando...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 5, px: 3 }}>
      {news.length > 0 && (
        <>
          <Typography variant="h4" sx={{ textAlign: "center", mb: 3 }}>
            Noticias Recientes
          </Typography>
          <Grid container spacing={3} justifyContent="center">
            {news.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={news.length === 1 ? 8 : 6}
                md={news.length === 1 ? 4 : 4}
                lg={news.length === 1 ? 3 : 3}  // Se añade breakpoint para pantallas grandes
                key={index}
              >
                <Card sx={{ height: "100%", maxWidth: 345, margin: "0 auto" }}>
                  <CardMedia
                    component="img"
                    loading="lazy"
                    image={item.image_url || "/images/placeholder.png"} // Imagen por defecto
                    alt={item.title}
                    srcSet={
                      item.image_url
                        ? `${item.image_url} 1x, ${item.image_url} 2x`
                        : undefined
                    }
                    sx={{
                      width: "100%",
                      height: 200,
                      objectFit: "cover",
                      transition: "transform 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                  <CardContent>
                    <Typography variant="h6">{item.title}</Typography>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                      {item.description}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="primary">
                      {item.link}
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
}

export default News;
